

import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mwc-avatar-group',
  exportAs: 'mwcAvatarGroup',
  template: ` <ng-content></ng-content> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'mwc-avatar-group'
  }
})
export class MwcAvatarGroupComponent {}
